import Box from '@mui/material/Box';
import { observer } from 'mobx-react';

import UserImage from "./image/User.png";
import CloverleafImage from "./image/Cloverleaf.png";
import EditImage from "./image/Edit.png";
import { useStore } from "../../state/MobxContext";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from '@mui/material';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';




function UserBar() {
    const { loginStore } = useStore();
    // const { CoinStore } = useStore();
    const { UserProfileStore } = useStore();
    const { SaleStore } = useStore();



    const useStyles = makeStyles((theme) => ({
        //UserImage
        UserImage: {
            width: "40px",
            height: "40px"
        },
        UserImageMobile: {
            flex: 1,
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        },
        //BasicUserImage
        BasicUserImage: {
            width: "40px",
            height: "40px"
        },
        BasicUserImageMobile: {
            flex: 1,
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        },


    }));

    const isMobile = useMediaQuery("(max-width: 600px)");
    const isSeven = useMediaQuery("(max-width: 700px)");
    const classes = useStyles();
    const CloverCount = loginStore?.CloverCount;
    const member_no = loginStore?.loginState?.member_no;
    const UserRecommenderInfo = UserProfileStore?.UserRecommenderInfo;
    const BusinessCode = UserRecommenderInfo?.business_code;
    const BusinessGrade = Number(UserRecommenderInfo?.business_grade);
    const isRecommenderPage = loginStore.isRecommenderPage;


    const Text = loginStore?.loginState?.member_nickname + "#" + BusinessCode;

    // console.log(Text);

    // console.log(BusinessGrade);

    let Guide_clover_page_userBar_01 = loginStore?.Guide_clover_page_userBar_01; //복사 하였습니다
    let ErrorGuide_clover_page_userBar_01 = loginStore?.ErrorGuide_clover_page_userBar_01; //복사에 실패하였습니다
    let ErrorGuide_clover_page_userBar_02 = loginStore?.ErrorGuide_clover_page_userBar_02; //복사하기가 지원되지 않는 브라우저입니다





    const copy = async () => {


        if (navigator.clipboard) {
            if (loginStore?.loginState?.member_nickname === undefined || loginStore?.loginState?.member_nickname === null || loginStore?.loginState?.member_nickname === "") {
                // console.log("111111");
                return alert(ErrorGuide_clover_page_userBar_01);
            }
            else {
                try {
                    if (BusinessCode !== undefined && BusinessCode !== null && BusinessGrade !== undefined && BusinessGrade !== null && Number(BusinessGrade) > 0) {
                        await navigator.clipboard.writeText(Text);
                        return alert(Guide_clover_page_userBar_01);
                    }
                    else {
                        await navigator.clipboard.writeText(loginStore?.loginState?.member_nickname);
                        return alert(Guide_clover_page_userBar_01);
                    }
                    // await navigator.clipboard.writeText(Text);
                    // return alert('복사 성공');
                } catch (error) {
                    // console.log(error);
                    // console.log("err",error);
                    return alert(ErrorGuide_clover_page_userBar_02);
                }
            }
        }
        else {
            if (!document.queryCommandSupported("copy")) {
                return alert(ErrorGuide_clover_page_userBar_02);
            }
            if (BusinessCode !== undefined && BusinessCode !== null && BusinessGrade !== undefined && BusinessGrade !== null && Number(BusinessGrade) > 0) {
                // await navigator.clipboard.writeText(Text);
                const $textarea = document.createElement('textarea');
                document.body.appendChild($textarea);
                // 2. props로 받은 text값을 textarea의 value로 대입하고 textarea 영역 내 모든 텍스트를 선택(드래그효과)
                $textarea.value = Text;
                $textarea.select();
                // 3. execCommand 함수를 이용해 클립보드에 복사
                document.execCommand('copy');
                // 4. 임시 textarea 요소 제거
                document.body.removeChild($textarea);
                return alert(Guide_clover_page_userBar_01);
            }
            else {
                // await navigator.clipboard.writeText(loginStore?.loginState?.member_nickname);
                const $textarea = document.createElement('textarea');
                document.body.appendChild($textarea);
                // 2. props로 받은 text값을 textarea의 value로 대입하고 textarea 영역 내 모든 텍스트를 선택(드래그효과)
                $textarea.value = loginStore?.loginState?.member_nickname;
                $textarea.select();
                // 3. execCommand 함수를 이용해 클립보드에 복사
                document.execCommand('copy');
                // 4. 임시 textarea 요소 제거
                document.body.removeChild($textarea);
                return alert(Guide_clover_page_userBar_01);
            }
        }
    }



    const WhiteTextTypography = withStyles({
        root: isMobile ? {
            fontSize: '0.8rem',
            color: "#FFFFFF",
        }
            : {
                fontSize: '1.4rem',
                color: "#FFFFFF",
            }
    })(Typography);

    return (
        <div>
            <Grid container direction="row" minWidth='full' justifyContent="space-between" alignItems="center" bgcolor='black' maxWidth='100%' mx='auto' p={1} borderRadius='6px' >
                <Grid item xs={12} sm={12} container direction="row" alignItems="center" >
                    <Grid item xs={2} sm={isSeven ? 2 : 1} md={1}  >
                        <Box sx={isMobile ? { display: 'flex', border: 2, borderColor: "White", width: '30px', height: '30px' }
                            : { display: 'flex', border: 2, borderColor: "White", width: '40px', margin: 1 }}>
                            {loginStore?.loginState?.profile_image !== null ?
                                <img className={isMobile ? classes.UserImageMobile : classes.UserImage} src={`${process.env.REACT_APP_PROFILE_IMAGE_SERVER}${loginStore?.loginState?.profile_image}`} alt="UserImage" />
                                : <img className={isMobile ? classes.BasicUserImageMobile : classes.BasicUserImage} src={UserImage} alt="UserImage" />
                            }
                        </Box>
                    </Grid>
                    <Grid container item xs={5} sm={isSeven ? 6 : 7} md={8} gap={2} >
                        <WhiteTextTypography  >
                            {
                                (BusinessCode !== undefined && BusinessCode !== null && BusinessCode !== "" && BusinessGrade !== undefined && BusinessGrade !== null && Number(BusinessGrade) > 0) ?
                                    Text
                                    :
                                    loginStore?.loginState?.member_nickname
                            }
                            
                        </WhiteTextTypography>
                        {/* <Grid item xs={1} sm={1} md={1} marginRight={isMobile ? "0" : "-5%"} /> */}
                        <FontAwesomeIcon icon={faCopy} size={isMobile ? 'sm' : 'xl'} color='White' onClick={(e) => { copy(Text !== undefined ? Text : '') }} />
                        
                    </Grid>
                    {isRecommenderPage === true?
                    <Grid container item xs={3} sm={3} md={2} 
                    justifyContent="flex-end" 
                    alignItems="center"
                    onClick={(e) => { loginStore.setDialogOpen("CloverSale") }} // 클로버 구입
                    >
                        <img src={CloverleafImage} 
                        style={isMobile ? { width: '30%' } : { width: '45px', height: '45px', marginRight: '10px' }} 
                        // onClick={(e) => { SaleStore.getCloverExchange("StandTest") }}//이미지 클로버 구입
                        alt="CloverleafImage" />
                        <WhiteTextTypography >
                        {/* {loginStore.Usercountry} */}
                            
                            {CloverCount !== undefined || CloverCount !== null || CloverCount !== 0 || CloverCount !== "" ?
                                [loginStore?.CloverCount].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                : "0"}
                        </WhiteTextTypography>
                    </Grid>
                    :
                    <Grid container item xs={3} sm={3} md={2} 
                    justifyContent="flex-end" 
                    alignItems="center"
                    // onClick={(e) => { loginStore.setDialogOpen("CloverSale") }} // 클로버 구입 (일반유저 x)
                    >
                        <img src={CloverleafImage} 
                        style={isMobile ? { width: '30%' } : { width: '45px', height: '45px', marginRight: '10px' }} 
                        // onClick={(e) => { SaleStore.getCloverExchange("StandTest") }}//이미지 클로버 구입
                        alt="CloverleafImage" />
                        <WhiteTextTypography >
                        {/* {loginStore.Usercountry} */}
                            
                            {CloverCount !== undefined || CloverCount !== null || CloverCount !== 0 || CloverCount !== "" ?
                                [loginStore?.CloverCount].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                : "0"}
                        </WhiteTextTypography>
                    </Grid>
                    }
                    {/* onClick={(e) => {loginStore.setDialogOpen("UserProfile")}} */}
                    {member_no !== undefined || member_no !== null || member_no !== "" ?
                        (<Grid container item xs={2} sm={1} md={1} justifyContent="flex-end" >
                            <img style={isMobile ? { width: '35px', height: '35px' } : { width: '45px', height: '45px' }} src={EditImage} alt="EditImage" onClick={(e) => { loginStore.setDialogOpen("UserProfile") }} />
                        </Grid>)
                        :
                        (<Grid container item xs={2} sm={1} md={1} justifyContent="flex-end" >
                            <img style={isMobile ? { width: '35px', height: '35px' } : { width: '45px', height: '45px' }} src={EditImage} alt="EditImage" onClick={(e) => { loginStore.setDialogOpen("UserProfile") }} />
                        </Grid>)
                    }
                </Grid>
            </Grid>
        </div>
    )
};

export default observer(UserBar);